import { Fragment } from 'react';
import { HiCheck } from 'react-icons/hi';
import { RiCloseFill as RemoveIcon } from 'react-icons/ri';
import styles from './DebtCard.module.scss';
import MeritoButton from '../common/MeritoButtons/MeritoButtons';
import CircularLoader from '../common/CircularLoader/CircularLoader';
import { ViewDocumentButton } from '../BankStatements/DocumentList';
import PdfIcon from '../../assets/images/financeStatement/revenueDetails/pdf.svg';
import { ClassificationTag } from './debtHelpers';

type Props = {
    fileName: string;
    // where the view button reads the file from: the server's copy, or the
    // local file while it is still uploading
    fileKey?: string;
    file?: File;
    // what the classifier found; hidden while the file is processing
    tags?: ClassificationTag[];
    // shows the spinner in place of the remove button
    isProcessing: boolean;
    onViewError: (message: string) => void;
    // left out for a file still uploading: nothing on the server to remove yet
    remove?: {
        onClick: () => void;
        disabled: boolean;
        loading: boolean;
    };
};

// One file on a debt card, used for both uploaded documents and the file
// currently uploading, so the two always look the same.
const DebtFileRow = ({ fileName, fileKey, file, tags = [], isProcessing, onViewError, remove }: Props) => (
    <div className={styles.fileRow}>
        <div className={styles.fileInfo}>
            <img className={styles.fileIcon} src={PdfIcon} alt="pdf" />
            <div className={styles.fileNameContainer}>
                <div className={styles.fileName}>{fileName}</div>
                {!isProcessing && tags.length ? (
                    <div className={styles.classificationTags}>
                        {tags.map((tag, index) => (
                            <Fragment key={tag.label}>
                                {index > 0 ? <span className={styles.dot} /> : null}
                                <div className={styles.classificationTag}>
                                    {tag.found ? (
                                        <HiCheck className={styles.classificationIcon} />
                                    ) : (
                                        <RemoveIcon className={styles.missingIcon} />
                                    )}
                                    <div>{tag.label}</div>
                                </div>
                            </Fragment>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
        <div className={styles.fileActions}>
            <ViewDocumentButton file={file} fileKey={fileKey} onError={onViewError} />
            {isProcessing || !remove ? (
                <CircularLoader width="24px" height="24px" />
            ) : (
                <MeritoButton
                    type="tertiary"
                    size="md2"
                    onlyIcon
                    hover={false}
                    ariaLabel={`Remove ${fileName}`}
                    icon={<RemoveIcon />}
                    disabled={remove.disabled}
                    loading={remove.loading}
                    onClick={remove.onClick}
                />
            )}
        </div>
    </div>
);

export default DebtFileRow;
